import React, { useEffect, useState } from "react";
import {
  fetchFormData,
  formatTimeOnly,
  formatDateOnly,
} from "../../utils/options";
import Footer from "../shared/Footer";
import Expense2Header from "./Expense2Header";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import PageHeader from "../shared/pageHeader/PageHeader";
import { useParams } from "react-router-dom";
import Table from "../shared/table/Table"; // <-- assuming you're using the same Table component

const ExpenseHistory = () => {
  const { id: expenseId } = useParams();
  const [expenseHistory, setExpenseHistory] = useState([]);
  const [expenseDetails, setExpenseDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (expenseId) {
      fetchTaskHistory();
      fetchTaskDetails(expenseId);
    }
  }, [expenseId]);

  const fetchTaskDetails = async (id) => {
    try {
      const formData = new FormData();
      formData.append("id", id);

      const result = await fetchFormData("expense/getById", formData, "POST");
      if (result && result.data) {
        setExpenseDetails(result.data);
      } else {
        setExpenseDetails({});
      }
    } catch (error) {
      console.error("Failed to fetch expense details:", error);
      setExpenseDetails({});
    }
  };
  const fetchTaskHistory = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("expense_id", expenseId);

      const response = await fetchFormData("expense-history", formData, "POST");

      if (response?.data) {
        setExpenseHistory(response.data);
      } else {
        setExpenseHistory([]);
      }
    } catch (error) {
      console.error("Failed to fetch task history:", error);
      setExpenseHistory([]);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      accessorKey: "ActionDetails",
      header: "Action Details",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "changed_at",
      header: "Action Date",
      cell: (info) => formatDateOnly(info.getValue()),
      defaultIsVisible: true,
    },
    {
      accessorKey: "changed_at",
      header: "Action Time",
      cell: (info) => formatTimeOnly(info.getValue()),
      defaultIsVisible: true,
    },
    {
      accessorKey: "changed_by_name",
      header: "Action Change By",
      defaultIsVisible: true,
      cell: ({ getValue }) => {
        const name = getValue();
        return name ? name.charAt(0).toUpperCase() + name.slice(1) : "";
      },
    },
  ];

  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader></PageHeader>
          <Expense2Header />
          <div className="main-content">
            <div className="row">
              <div className="task-details mb-6">
                <h5 className="section-title">Expense Details</h5>
                <form className="details-font">
                  {/* Row 1 */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">Employee Name:</div>
                    <div className="col-2">
                      {expenseDetails.employee_name || "-"}
                    </div>
                    <div className="col-2 fw-semibold">Amount:</div>
                    <div className="col-2">{expenseDetails.amount || "-"}</div>
                    <div className="col-2 fw-semibold">Sanction amount:</div>
                    <div className="col-2">
                      {expenseDetails.sectionamount || "-"}
                    </div>
                  </div>
                  {/* row 2 */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">Payment Settled:</div>
                    <div className="col-2">
                      {expenseDetails.payment_settled || "-"}
                    </div>
                    <div className="col-2 fw-semibold">Transaction Id:</div>
                    <div className="col-2">
                      {expenseDetails.transaction_id || "-"}
                    </div>

                    <div className="col-2 fw-semibold">Expense Category:</div>
                    <div className="col-2">
                      {expenseDetails.category_name || "-"}
                    </div>
                  </div>

                  {/* Row 3 */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">
                      Travelling Description:
                    </div>
                    <div className="col-2">
                      {expenseDetails.travelling_description || "-"}
                    </div>
                    <div className="col-2 fw-semibold">Travelling Date:</div>
                    <div className="col-2">
                      {expenseDetails.travelling_date
                        ? formatDateOnly(expenseDetails.travelling_date)
                        : "-"}
                    </div>
                    <div className="col-2 fw-semibold">Created At:</div>
                    <div className="col-2">
                      {expenseDetails.created_at
                        ? formatDateOnly(expenseDetails.created_at)
                        : "-"}
                    </div>
                  </div>

                  {/* Row 3 (Full width for details) */}
                  <div className="row mb-3">
                 
                  </div>
                </form>
              </div>
              <Table data={expenseHistory} columns={columns} />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default ExpenseHistory;
